import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Col, Row, Space, Typography } from 'antd';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';
import { SummaryCard } from '../styles/styles';
import { getFullName, getPhone } from '../../../../utility/finalCustomerUtils';
import { finalCustomerSolutionIdRules } from '../../../../config/constants/finalCustomerSolutionRuleConstants';

const { Text } = Typography;

export const FinalCustomerCard = ({ selectedCustomer }) => {
  const { translate: t } = useDictionaryTranslation();
  const solutionId = useSelector((state) => state.auth?.accountData?.solutionId);
  const finalCustomerSolutionRules = finalCustomerSolutionIdRules[solutionId] ?? finalCustomerSolutionIdRules.default;

  const finalCustomerValues = selectedCustomer
    ? [
        {
          labelKey: 'documentType',
          value: selectedCustomer.identificationType,
        },
        {
          labelKey: 'identification',
          value: selectedCustomer.identification,
        },
        {
          labelKey: 'fullName',
          value: getFullName(selectedCustomer, { useFullName: finalCustomerSolutionRules.showName1 }),
        },
        {
          labelKey: 'email',
          value: selectedCustomer.email,
        },
        {
          labelKey: 'contactNumber',
          value: getPhone(selectedCustomer),
        },
        {
          labelKey: 'address',
          value: selectedCustomer.address,
        },
        {
          labelKey: 'birthDate',
          value: selectedCustomer.birthDate ? moment(selectedCustomer.birthDate).format('DD-MM-YYYY') : null,
        },
        {
          labelKey: 'healthInsurance',
          value: selectedCustomer.healthInsuranceData?.name,
        },
      ]
    : [];

  return (
    <SummaryCard title={t('finalCustomerInfo')}>
      <Row justify="space-between">
        {finalCustomerValues.map(
          (item) =>
            item.value && (
              <Col xs={24} md={12} key={item.labelKey}>
                <Space size={0} direction="vertical" align="start">
                  <Text strong>{t(item.labelKey)}:</Text>
                  <Text>{item.value}</Text>
                </Space>
              </Col>
            ),
        )}
      </Row>
    </SummaryCard>
  );
};

FinalCustomerCard.propTypes = {
  selectedCustomer: PropTypes.object,
};
